<template>
  <div id="sd-register">
    <header>
      <div class="close-wrapper">
        <img src="../../assets/img/login-img/1-注册-关闭ic@2x.png" alt="" class="close-icon" @click="goBack">
      </div>
      <div class="header-text">
        <p class="register-text">{{isRegister}}</p>
        <div class="header-right" v-if="isFindPwd !== 'true'" @click="goRouter('SdLogin')">
          <p class="count-login">已有账号登陆</p>
          <img src="../../assets/img/login-img/1-注册-下一步ic@2x.png" alt="" class="more-icon">
        </div>

      </div>
    </header>
    <!-- 输入框 -->
    <div class="input-wrapper">
      <ul>
        <li class="item-wrapper">
          <img src="../../assets/img/login-img/1-注册-用户ic@2x.png" alt="" class="input-icon">
          <input type="number" placeholder="请输入手机号" pattern="[0-9]*" class="input-text" v-model="mobile">
        </li>
        <li class="item-wrapper">
          <img src="../../assets/img/login-img/1-注册-验证码ic@2x.png" alt="" class="input-icon">
          <input type="number" placeholder="请输入验证码" pattern="[0-9]*" class="input-text" v-model="inputSms">
          <p class="get-msg" v-if="!timeFlag>0" @click="sendMsg">获取验证码</p>
          <p class="get-msg" v-if="timeFlag>0">{{timeFlag}}s再次发送</p>
        </li>
        <li class="item-wrapper">
          <img src="../../assets/img/login-img/1-注册-密码ic@2x.png" alt="" class="input-icon">
          <input type="password" placeholder="请输入密码" class="input-text" v-model="inputPwd">
        </li>
      </ul>
      <van-button size='large' type="primary" class="submit-button" @click="onSubmit">{{buttonText}}</van-button>
    </div>
    <!-- end -->
  </div>
</template>

<script>
import api from "@/api/index";
export default {
  data () {
    return {
      mobile: '',
      isFindPwd: false,
      isRegister: '注册',
      inputSms: '',
      buttonText: '',
      inputPwd: '',
      timeFlag: 0,
      timeInterVal: null
    }
  },
  beforeMount () {
    if (this.$route.query.isFindPwd === '找回密码') {
      this.isFindPwd = '找回密码'
      this.isRegister = '找回密码'
      this.buttonText = '提交'
    } else {
      this.isRegister = '注册'
      this.buttonText = '注册'
    }
  },
  watch: {},
  methods: {
    currentBtnText () {},
    // 发送验证码
    sendMsg () {
      console.log(this.isFindPwd, 'isfindpwd')
      if (this.isFindPwd === '找回密码') {
        if (this.currentMobile()) {
          let data = {
            mobile: this.mobile,
            action: 'findpassword'
          }
          let url = `${api.sendSms}?mobile=${data.mobile}&action=${
            data.action
          }`
          this.fetch(url)
        }
      } else {
        if (this.currentMobile()) {
          let data = {
            mobile: this.mobile,
            action: 'signup'
          }
          console.log(data)
          let url = `${api.sendSms}?mobile=${data.mobile}&action=${
            data.action
          }`
          this.fetch(url)
        }
      }
    },
    // 验证手机号
    currentMobile () {
      if (this.mobile === '') {
        this.$toast('手机号不能为空')
        return false
      } else return true
    },
    // 提交验证
    currentSubmit () {
      if (this.currentMobile()) {
        // let pwdReg = /^[0-9A-Za-z]{6,20}$/
        let pwdReg = /^[0-9a-zA-Z]{6,16}$/
        if (this.inputSms === '') {
          this.$toast('验证码不能为空')
          return false
        }
        if (this.inputPwd !== '') {
          if (!pwdReg.test(this.inputPwd)) {
            this.$toast('请输入6-16位数字或字母的组合')
            return false
          } else {
            return true
          }
        } else {
          this.$toast('密码不能为空')
          return false
        }
      }
    },
    // 封装请求
    fetch (url) {
      // this.$ObjToFd(data)
      this.$http.get(url).then(res => {
        if (res.data.code == 0) {
          this.$toast('发送成功')
          // 发送倒计时
          let flag = 60
          this.timeInterVal = setInterval(() => {
            this.timeFlag = --flag
            if (flag === 0) {
              clearInterval(this.timeInterVal)
            }
          }, 1000)
        } else {
          this.$toast(res.data.message)
        }
      })
    },
    goRouter (val) {
      this.$router.push(val)
    },
    // 提交
    onSubmit () {
      if (this.currentSubmit()) {
        if (this.isFindPwd !== '找回密码') {
          // 注册
          // let url = '/site/signup'
          let params = {
            mobile: this.mobile,
            password: this.inputPwd,
            vcode: this.inputSms,
            openid: localStorage.getItem('openid')
          }
          let url = `${api.singUp}?mobile=${params.mobile}&password=${
            params.password
          }&vcode=${params.vcode}&openid=${params.openid}`
          this.$http.get(url, this.$ObjToFd(params)).then(res => {
            if (res.data.code == 0) {
              localStorage.setItem('token', res.data.data.result.token)
              localStorage.setItem('secret', res.data.data.result.secret)
              this.$router.push('SdUserInfo')
              this.$setToken(localStorage.getItem('token'))
              this.$toast('注册成功')
            } else {
              this.$toast(res.data.message)
            }
          })
        } else {
          // 找回密码
          console.log('我是找回密码')
          let url = api.findPassword
          let params = {
            username: this.mobile,
            password: this.inputPwd,
            vcode: this.inputSms
          }
          console.log(params, '我是上传的参数')
          this.$http.post(url, this.$ObjToFd(params)).then(res => {
            console.log(res.data, '我是找回密码')
            console.log(res.data, 'res.data')
            console.log(res.data.code, 'res.data.code')
            console.log(res, 'ressss')
            if (res.data.code == 0) {
              this.$toast('修改成功')
              localStorage.clear()
              let token = res.data.data.result.token
              let secret = res.data.data.result.secret
              localStorage.setItem('token', token)
              localStorage.setItem('secret', secret)
              this.$http.defaults.headers.common['x-token'] =
              res.data.data.result.token
              this.$router.push('/SdSeeDoctor')
            } else {
              this.$toast(res.data.message)
            }
          })
        }
      }
    },
    goBack () {
      this.$router.push('/SdSeeDoctor')
      // if (this.$router.back(-1) !== 'undefined') {
      //   this.$router.back(-1)
      // } else {
      //   this.$router.push('/SdSeeDoctor')
      // }
    }
  }
}
</script>

<style lang="postcss">
#sd-register {
  height: 100%;
  width: 100%;
  background-color: #fffffd;
  /* background-color: red; */
  position: absolute;
  & header {
    width: 100%;
    padding-top: 63px;
    & .close-wrapper {
      height: 36px;
      margin-bottom: 29px;
      width: 100%;
      & .close-icon {
        position: absolute;
        right: 63px;
        height: 36px;
        width: 36px;
      }
    }
    & .header-text {
      position: absolute;
      width: 100%;
      box-sizing: border-box;
      background-color: #fffffd;
      display: flex;
      padding: 0 38px;
      padding-bottom: 294px;
      padding-top: 30px;
      justify-content: space-between;
      & .register-text {
        font-size: 48px;
        color: #333333;
        font-family: "SourceHanSansCN-Medium";
        font-weight: bold;
      }
      & .header-right {
        display: flex;
        /* align-items: center; */
        align-items: flex-end;

        & .count-login {
          font-size: 28px;
          margin-right: 20px;
        }
        & .more-icon {
          width: 20px;
          height: 36px;
          font-family: "SourceHanSansCN-Regular";
        }
      }
    }
  }
  & .input-wrapper {
    background-color: #fffffd;
    position: absolute;
    top: 275px;
    padding-top: 294px;
    padding: 0 38px;
    width: 100%;
    box-sizing: border-box;
    & .item-wrapper {
      position: relative;
      display: flex;
      width: 100%;
      margin-bottom: 45px;
      background-color: #fffffd;
      & .input-icon {
        position: absolute;
        top: 50%;
        margin-top: -14px;
        width: 28px;
        height: 28px;
      }
      & .input-text {
        border: none;
        border-bottom: 1px solid #d7d7d7;
        line-height: normal;
        border-radius: 0;
        width: 100%;
        font-family: 'SimHei';
        padding: 20px 0;
        padding-left: 57px;
        font-size: 30px;
        color: #333;
        background-color: #fffffd;
      }
      & .input-text::-webkit-input-placeholder{
        color: #999;
      }
      & .get-msg {
        font-size: 28px;
        color: #ff7e00;
        position: absolute;
        right: 0;
        top: 50%;
        margin-top: -14px;
      }
    }
    & .submit-button {
      border-radius: 50px;
      font-size: 32px;
      margin-top: 122px;
      box-shadow:3px 3px 8px 3px rgba(34,85,06,0.2);
      border: 2px solid #2E9817;
      height: 88px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/shenduLogin/SdRegister.vue